import { render, staticRenderFns } from "./field-duplicate.vue?vue&type=template&id=0b443cd9&scoped=true&"
import script from "./field-duplicate.vue?vue&type=script&lang=js&"
export * from "./field-duplicate.vue?vue&type=script&lang=js&"
import style0 from "./field-duplicate.vue?vue&type=style&index=0&id=0b443cd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b443cd9",
  null
  
)

export default component.exports